import { ViewDay } from "@mui/icons-material";

export const StepContainerConfig = {
    type: 17,
    label: 'Stepper',
    icon: ViewDay,
    allowedBy: [2],
    autoConfig: false,
}